<div
  class="sky-coach-panel"
  data-testid="sky-coach-panel"
  [class.sky-coach-panel-inline]="layout === 'inline'"
  [class.sky-coach-panel-compact]="layout === 'compact'"
  [class.sky-coach-panel-result]="layout === 'result'"
  [class.sky-coach-panel-framed]="framed">
  <div class="sky-coach-copy">
    @if (kicker) {
      <span class="sky-coach-kicker">{{ kicker }}</span>
    }
    @if (title) {
      <h3 class="sky-coach-title">{{ title }}</h3>
    }
    <p class="sky-coach-message">{{ state.message }}</p>
    <ng-content select="[skyCopyExtra]"></ng-content>
    @if (state.statusLabel) {
      <div class="sky-coach-status">
        <span>Status</span>
        <strong>{{ state.statusLabel }}</strong>
      </div>
    }
  </div>
  <div class="sky-coach-figure">
    <app-sky-character
      [pose]="state.pose"
      [playSituation]="playSituation" />
  </div>
</div>
